
























import { Component, Mixins, Vue } from "vue-property-decorator";

import ContainImage from "@/components/ContainImage.vue";
import ExternalLink from "@/components/ExternalLink.vue";

import {
  URL_PARAM_CP_ID,
  URL_PARAM_SERIAL_CODE,
  URL_PARAM_REDIRECT_CODE,
} from "@/utils/url";
import SettingMixin from "@/mixins/settingMixin";

@Component({
  components: {
    ContainImage,
    ExternalLink,
  },
})
export default class AddFriend extends Mixins(Vue, SettingMixin) {
  get campaignIdParam(): string {
    return URL_PARAM_CP_ID;
  }
  get serialCodeParam(): string {
    return URL_PARAM_SERIAL_CODE;
  }
  get redirectCodeParam(): string {
    return URL_PARAM_REDIRECT_CODE;
  }
  get text(): unknown {
    return this.config.addFriend.text;
  }
  get basePath(): unknown {
    if (window.location.host.indexOf("dev") != -1)
      return this.config.addFriend.baseUrl.dev;
    if (window.location.host.indexOf("stg") != -1)
      return this.config.addFriend.baseUrl.stg;
    return this.config.addFriend.baseUrl.prd;
  }

  async mounted(): Promise<void> {
    const isOpen = await this.checkCampaignStatus();
    if (!isOpen) return;
    // postActionLog(
    //   this.campaignId,
    //   this.token,
    //   this.serialCode,
    //   "",
    //   "add_friend"
    // );
  }

  get bannerAddFriend(): string {
    return this.config.imageName.addFriend?.bannerAddFriend
      ? `./images/campaign/${this.config.imageName.addFriend.bannerAddFriend}`
      : "";
  }

  get addFriendButton(): string {
    return this.config.imageName.addFriend?.addFriendButton
      ? `./images/campaign/${this.config.imageName.addFriend.addFriendButton}`
      : "";
  }
}
